import { memo } from 'react';

import { PM_COLLABORATING } from 'CorePackage/MainModule/routes/routes';
import {
  COLLABORATING_ORGANIZATIONS_BLOCK_ID,
  getCollaboratingOrganizationBlockId,
} from 'KnmPmPackage/MainModule/constants/knmPmFieldsElementsIds';
import { ErknmCollaboratingOrganizations } from 'KnmPackage/MainModule/components/ErknmCollaboratingOrganizations';

interface IPmCollaboratingProps {
  className?: string;
  created: string | undefined;
  watchOnly: boolean;
  isHasCollaboratingOrganization: boolean | undefined;
}

export const PmCollaborating = memo(
  ({ className = '', created, watchOnly, isHasCollaboratingOrganization }: IPmCollaboratingProps) => {
    return (
      <div className={className} id={PM_COLLABORATING}>
        <h2 className="shared-title__with-margin">
          Проведение мероприятия в форме совместного (межведомственного) профилактического мероприятия
        </h2>

        <ErknmCollaboratingOrganizations
          created={created}
          watchOnly={watchOnly}
          organizationsBlockId={COLLABORATING_ORGANIZATIONS_BLOCK_ID}
          fieldsLabel="Наименование КНО с которым ПМ проводится совместно"
          isHasCollaboratingOrganization={isHasCollaboratingOrganization}
          getOrganizationsItemBlockId={getCollaboratingOrganizationBlockId}
        />
      </div>
    );
  },
);
